<template>
  <div class="nav-tabs-wrapper d-flex align-items-center">
    <!-- Left arrow -->
    <button class="scroll-btn left px-2" @click="scrollLeft">
      ‹
    </button>

    <!-- Scrollable tabs -->
    <div class="tabs-container flex-grow-1" ref="tabsContainer">
      <ul class="nav nav-tabs flex-nowrap">
        <slot></slot>
      </ul>
    </div>

    <!-- Right arrow -->
    <button class="scroll-btn right px-2" @click="scrollRight">
      ›
    </button>
  </div>
</template>

<script setup>
import { ref } from "vue";

const tabsContainer = ref(null);

const scrollLeft = () => {
  if (tabsContainer.value) {
    tabsContainer.value.scrollBy({ left: -200, behavior: "smooth" });
  }
};

const scrollRight = () => {
  if (tabsContainer.value) {
    tabsContainer.value.scrollBy({ left: 200, behavior: "smooth" });
  }
};
</script>

<style scoped>
.nav-tabs-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.tabs-container {
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
}
.tabs-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.nav-tabs {
  flex-wrap: nowrap !important;
  white-space: nowrap;
}

.scroll-btn {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  z-index: 2;
}
.scroll-btn.left {
  margin-right: 5px;
}
.scroll-btn.right {
  margin-left: 5px;
}
</style>
